// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VIiA","colBig":"styles_colBig__1K2qA","colSmall":"styles_colSmall__2aymN","shopifyNameWrapper":"styles_shopifyNameWrapper__2498m"};